import { Button, Card, Divider, Icon } from '@blueprintjs/core';
import { ace } from '@axo/shared/data-access/types';
import { useClientEmail } from '@axo/shared/data-access/hooks';
import { getLocalPartOfEmail } from '../../utils/getLocalPartOfEmail';
import { dateToRelativeTime } from '../../utils/dateToRelativeTime';
import { SmallTag } from '../SmallTag';
import styles from './TransferNotification.module.css';

interface TransferNotificationProps {
  notification: ace.Notification;
  senderInitials: string;
  humanReadableID?: string;
  onClick: () => void;
  action?: { label: string; onClick: () => void; isLoading: boolean };
}

export function TransferNotification({
  notification,
  senderInitials,
  humanReadableID,
  onClick,
  action,
}: TransferNotificationProps) {
  const receiverEmail = useClientEmail(notification.ClientID);
  const receiverInitials = receiverEmail.data
    ? getLocalPartOfEmail(receiverEmail.data)
    : '...';

  return (
    <Card onClick={() => onClick()} className={styles.card} interactive>
      <div className={styles.topRow}>
        <span className={styles.applicationLabel}>
          <Icon icon="applications" size={14} intent="success" />
          Application: {humanReadableID || notification.LoanApplicationID}
        </span>
        <span className={styles.time}>
          {dateToRelativeTime(notification.CreatedAt)}
        </span>
      </div>

      <Divider />

      <div className={styles.transferRow}>
        <SmallTag minimal intent="success">
          {senderInitials}
        </SmallTag>
        <span className={styles.arrow}>&rarr;</span>
        <SmallTag minimal intent="success">
          {receiverInitials}
        </SmallTag>
      </div>

      <div className={styles.body}>
        <strong>{senderInitials} has transferred the ownership</strong> of this
        application to you. Open the application view by clicking on this card.
      </div>

      {action && (
        <div className={styles.bottomRow}>
          <Button
            minimal
            small
            intent="primary"
            onClick={(e) => {
              e.stopPropagation();
              action.onClick();
            }}
            loading={action.isLoading}
          >
            {action.label}
          </Button>
        </div>
      )}
    </Card>
  );
}
